/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { z, ZodTypes } from '../index';

export const SERVICE_TYPES = ['postgres', 'pgee', 'cypex', 'migrator', 'babelfish'] as const;
export type ServiceType = (typeof SERVICE_TYPES)[number];

export const SERVICE_TYPE_UUIDS = {
  postgres: '14a94361-b480-484f-b7d3-acfd890efe89',
  pgee: '7a618133-8e2d-431f-a723-bb8a246ee96d',
  cypex: 'f65a7e8b-8c9e-486c-81ca-a08646a4e8ab',
  migrator: '4754936e-b959-4b9a-95d0-e3f2b262bd6c',
  babelfish: 'e95e470b-b8d7-453c-9a59-baaa87404c1e',
} as const satisfies Record<z.infer<typeof ZodTypes.ServiceType>, string>;

export const ServiceTypeMatrix = {
  sourceClusterForCreatingPostgresqlFromBackup: {
    postgres: true,
    pgee: true,
    cypex: false,
    migrator: false,
    babelfish: false,
  },
  displayClusterCredentials: {
    postgres: true,
    pgee: true,
    cypex: true,
    migrator: false,
    babelfish: true,
  },
  displayApplication: {
    postgres: false,
    pgee: false,
    cypex: false,
    migrator: true,
    babelfish: false,
  },
  displayAdvice: {
    postgres: true,
    pgee: true,
    cypex: false,
    migrator: false,
    babelfish: false,
  },
  displayParameters: {
    postgres: true,
    pgee: true,
    cypex: false,
    migrator: false,
    babelfish: true,
  },
  displayAcl: {
    postgres: true,
    pgee: true,
    cypex: true,
    migrator: false,
    babelfish: true,
  },
  displayReplicas: {
    postgres: true,
    pgee: true,
    cypex: false,
    migrator: false,
    babelfish: false,
  },
  displayBackups: {
    postgres: true,
    pgee: true,
    cypex: true,
    migrator: false,
    babelfish: false,
  },
  displayDatasets: {
    postgres: true,
    pgee: true,
    cypex: false,
    migrator: false,
    babelfish: false,
  },
  manageClusterLifecycle: {
    postgres: true,
    pgee: false,
    cypex: false,
    migrator: false,
    babelfish: false,
  },
} as const satisfies Record<string, Record<ServiceType, boolean>>;
